<p>Schreiben Sie einfacher und schneller Ihre Mails!</p>

<style>
    p {
        text-align: center;
    }
</style>